import React from 'react';

import { fg } from '@confluence/feature-gating';

import { Bm3PageLoadMark } from '../Bm3PageLoadMark.tsx';
import type { Props } from '../Bm3PageLoadMark.tsx';

import { UFOLoadMark } from './UFOLoadMark.tsx';

/**
 * Interop component that renders either the new UFOLoadMark (which records a
 * UFO custom mark) or the legacy Bm3PageLoadMark (which creates BM3 marks)
 * based on the `confluence_fe_deprecate_bm3` feature gate.
 */
export const PageLoadMark = (props: Props) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		return <UFOLoadMark {...props} />;
	}

	return <Bm3PageLoadMark {...props} />;
};
